// API Configuration
// Automatically switches based on environment:
// - npm start → development
// - npm run build → production
const IS_PRODUCTION = process.env.NODE_ENV === "production";

const API_CONFIG = {
	BASE_URL: IS_PRODUCTION
		? "https://api.gymnote.fr/gymnote"
		: "http://localhost:5288/gymnote",

	TIMEOUT: 30000,
};

export const GOOGLE_CLIENT_ID =
	"343961493802-h3u6al5h7o3v63d441d5123vboqqq4kq.apps.googleusercontent.com";

// Apple Sign-In for Web
// To configure: Apple Developer > Certificates > Service IDs > create one with "Sign In with Apple" enabled
// Set the redirect URL to your website domain (e.g. https://gymnote.fr)
export const APPLE_CLIENT_ID = "fr.gymnote.web"; // Replace with your actual Apple Service ID
export const APPLE_REDIRECT_URI = IS_PRODUCTION
	? "https://gymnote.fr"
	: "http://localhost:3000";

export default API_CONFIG;
